import { string } from 'prop-types';
import React from 'react';

import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

/**
 * Show selected price tier name from protectedData when present.
 */
const LineItemPriceTierMaybe = props => {
  const { transaction, intl } = props;
  const tier = transaction?.attributes?.protectedData?.priceTier;
  if (!tier?.name) {
    return null;
  }

  return (
    <div className={css.lineItem} data-testid="order-breakdown-price-tier">
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.priceTierLabel" />
      </span>
      <span className={css.itemValue}>{tier.name}</span>
    </div>
  );
};

LineItemPriceTierMaybe.propTypes = {
  transaction: propTypes.transaction.isRequired,
  intl: intlShape.isRequired,
  className: string,
};

export default LineItemPriceTierMaybe;
